import type { CSSProperties } from 'react';
import { WEDGE_SETTINGS_ACTION } from '@territory/tokens';
import { font, radius, space, weight } from '../scale.js';
import { wedgeExactRole } from './wedgeRoles.js';

export type WedgePhonePrivacyLook = 'phone-privacy-ack' | 'phone-privacy-cancel';
export const isWedgePhonePrivacyLook = (look: string | undefined): look is WedgePhonePrivacyLook => look === 'phone-privacy-ack' || look === 'phone-privacy-cancel';

// Preserve the Phone notice geometry. Neither control adds a transparent hit area.
export function wedgePhonePrivacyStyle(look: WedgePhonePrivacyLook): CSSProperties {
  if (look === 'phone-privacy-ack') return {
    width: '100%', height: 50, borderRadius: radius.xl,
    background: wedgeExactRole('label'), color: wedgeExactRole('bg'),
    border: 0, cursor: 'pointer', fontSize: font.callout, fontWeight: weight.bold, fontFamily: wedgeExactRole('font'),
    boxShadow: WEDGE_SETTINGS_ACTION.sheetShadow,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: space[2],
  };
  return {
    display: 'block', width: '100%', background: 'none', border: 0,
    color: wedgeExactRole('labelSec'), fontSize: font.body, fontWeight: weight.medium,
    padding: 14, marginTop: space[1], cursor: 'pointer', fontFamily: wedgeExactRole('font'),
  };
}
